"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var MuiBackdrop = function MuiBackdrop(theme) {
  return {
    root: {
      backgroundColor: (0, _colorManipulator.fade)(theme.palette.grey[700], 0.8)
    }
  };
};

var _default = MuiBackdrop;
exports["default"] = _default;